import { runbookServerService } from "../services/runbookServer.service";
import { runbookServerConstants } from "../constants/runbookServer.constants";

export const runbookServerActions = {
  getAll,
  get,
  getById,
  create,
  update,
  remove,
};

function getAll() {
  return (dispatch) => {
    dispatch(request());

    runbookServerService.getAll().then(
      (response) => {
        dispatch(success(response.data));
      },
      () => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return {
      type: runbookServerConstants.GET_ALL_REQUEST,
    };
  }
  function success(result) {
    return { type: runbookServerConstants.GET_ALL_SUCCESS, payload: result };
  }
  function failure() {
    return { type: runbookServerConstants.GET_ALL_FAILURE };
  }
}

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookServerService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: runbookServerConstants.GET_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return {
      type: runbookServerConstants.GET_SUCCESS,
      payload: paginatedResult,
    };
  }
  function failure() {
    return { type: runbookServerConstants.GET_FAILURE };
  }
}

function getById(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookServerService.getById(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: runbookServerConstants.GET_BY_ID_REQUEST,
      payload: requestParameters,
    };
  }
  function success(server) {
    return {
      type: runbookServerConstants.GET_BY_ID_SUCCESS,
      payload: server,
    };
  }
  function failure() {
    return {
      type: runbookServerConstants.GET_BY_ID_FAILURE,
    };
  }
}

function create(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookServerService.create(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: runbookServerConstants.CREATE_REQUEST,
      payload: requestParameters,
    };
  }
  function success() {
    return { type: runbookServerConstants.CREATE_SUCCESS };
  }
  function failure() {
    return { type: runbookServerConstants.CREATE_FAILURE };
  }
}

function update(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookServerService.update(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: runbookServerConstants.UPDATE_REQUEST,
      payload: requestParameters,
    };
  }
  function success() {
    return { type: runbookServerConstants.UPDATE_SUCCESS };
  }
  function failure() {
    return { type: runbookServerConstants.UPDATE_FAILURE };
  }
}

function remove(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    runbookServerService.remove(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        const errorMessage = error.response?.data?.message || error.response?.data || error.message || "Failed to delete server";
        dispatch(failure(errorMessage));
      }
    );
  };

  function request() {
    return {
      type: runbookServerConstants.DELETE_REQUEST,
    };
  }
  function success() {
    return {
      type: runbookServerConstants.DELETE_SUCCESS,
    };
  }
  function failure(errorMessage) {
    return {
      type: runbookServerConstants.DELETE_FAILURE,
      payload: errorMessage
    };
  }
}
